import React from 'react'
import SearchResultVersionItem from './SearchResultVersionItem'
import SearchResultVersionTitle from './SearchResultVersionTitle'
import styles from './styles.module.css'

function SearchResultVersionGroup({ versions }) {
  return (
    <ul className={styles.searchResultList}>
      {versions.map(({ version, result }, index) => (
        <li key={index}>
          <SearchResultVersionTitle version={version} />

          <ul className={styles.searchResultList}>
            {result.map(({ slug, hash, title, description }, resultIndex) => (
              <SearchResultVersionItem slug={slug} hash={hash} title={title} description={description} key={resultIndex} />
            ))}
          </ul>
        </li>
      ))}
    </ul>
  )
}

export default SearchResultVersionGroup
